import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { OauthState } from '@/redux/oauth/oauth.types';
import { getOAuth } from '@/redux/oauth/oauth.thunks';
import { ONE } from '@/constants/common';

export const getOauthReducer = (builder: ActionReducerMapBuilder<OauthState>): void => {
  builder.addCase(getOAuth.pending, state => {
    state.loading = 'pending';
  });
  builder.addCase(getOAuth.fulfilled, (state, action) => {
    state.data = action.payload;
    for (let i = 0; i < action.payload.length; i += ONE) {
      if (action.payload[i].name === 'Orcid') {
        state.orcidEndpoint = action.payload[i].uri;
      }
    }
    state.loading = 'succeeded';
  });
  builder.addCase(getOAuth.rejected, state => {
    state.loading = 'failed';
    // TODO to discuss manage state of failure
  });
};
